<template>
  <div class="my-1" v-if="priceData">
    <div class="section text-center">
      <table class="mx-auto">
        <tr
          v-for="(qty, index) in priceData.meta.quantities"
          :key="index"
          class=""
        >
          <td class="pa-1">
            <span v-if="getPriceForQuantity(qty)">{{
              getPriceForQuantity(qty) | currency
            }}</span>
            <span v-else> ? </span>
          </td>

          <td class="d-table-cell pa-1">
            / {{ qty }} pack
            <span class="caption ml-2">{{ approxDuration(qty) }}</span>
          </td>
        </tr>
      </table>

      <transition name="fade">
        <v-card
          flat
          rounded
          v-show="priceData.meta.quantities.length < 1"
          color="yellow lighten-5"
        >
          No prices have been set for this lens.
        </v-card>
      </transition>
      <v-dialog v-model="addEditDialog" width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn outlined small rounded v-bind="attrs" v-on="on" class="my-2">
            Add/Edit Prices
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="editTitleBkg text-wrap">{{
            brand.name
          }}</v-card-title>
          <v-card-subtitle class="editTitleBkg"
            >Add/Edit Prices</v-card-subtitle
          >
          <v-card-text class="py-4">
            <set-brand-price
              class="ma-2"
              :lens_id="brand.id"
              :lens_name="brand.name"
              :existingPrices="priceData"
              @dismiss="addEditDialog = false"
              @priceDataChange="emitPrice($event)"
            ></set-brand-price>
            <!-- priceDataChange will be triggered if the user changes the price.  We'll pass this back to the parent (EyeLensPanel), which will reset this component's prop -->
          </v-card-text></v-card
        >
      </v-dialog>
    </div>
  </div>
</template>

<script>
import SetBrandPrice from "./SetBrandPrice.vue";
// import Name from "../dir/file";

export default {
  components: { SetBrandPrice },
  name: "LensPriceDetails",
  props: {
    priceData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    brand: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return { addEditDialog: null };
  },
  methods: {
    approxDuration: function (qty) {
      let duration = this.getQuantityInfo(qty, "approxDuration");
      return duration ? ` (${duration}) ` : "";
    },

    getPriceForQuantity(qty) {
      let price = this.getQuantityInfo(qty, "retail");
      return price ? price : " ? ";
    },
    getQuantityInfo(qty, parameter) {
      if (!this.priceData) return null;
      if (!this.priceData.practice) return null;
      if (!this.priceData.practice.boxes) return null;
      let path = this.priceData.practice.boxes;
      if (!path[qty]) return null;
      if (!path[qty][parameter]) return null;
      return path[qty][parameter];
    },
    emitPrice(price) {
      // console.log("emitting price", price);
      this.$emit("priceDataChange", price);
    },
  },
  computed: {},
};
</script>

<style scoped>
.section {
  margin: 1em 0;
}

.editTitleBkg {
  background-color: #d1e8ff;
}
</style>
